const STRIPE_JS_URL = 'https://js.stripe.com/v3/'

let stripeJsPromise = null

// Injects Stripe.js on first use only, so non-payment pages never load it (ordit1/tasks/tasks#117).
export default function loadStripeJs() {
    if (window.Stripe) return Promise.resolve(window.Stripe)
    if (!stripeJsPromise) {
        const script = document.createElement('script')
        script.src = STRIPE_JS_URL
        script.async = true
        stripeJsPromise = new Promise((resolve, reject) => {
            script.onload = () =>
                window.Stripe
                    ? resolve(window.Stripe)
                    : reject(new Error('Stripe.js loaded without window.Stripe'))
            script.onerror = () => reject(new Error('Stripe.js could not be loaded'))
        }).catch((e) => {
            stripeJsPromise = null
            script.remove()
            throw e
        })
        document.head.appendChild(script)
    }
    return stripeJsPromise
}
